import createIcon from '../../createIcon';

/**
 * @component @name FastRewind
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNzUgMThWNkwzLjI1IDEyTDExLjc1IDE4Wk0xMi4yNSAxMkwyMC43NSAxOFY2TDEyLjI1IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FastRewind = createIcon('FastRewind', [
  ['path', { d: 'M11.75 18V6L3.25 12L11.75 18ZM12.25 12L20.75 18V6L12.25 12Z', key: 'wverei' }],
]);

export default FastRewind;
